import { isFactSetIntentBridgeAvailable } from "./factset/intentBridgeService";
import { isFactSetSpreadsheetHost } from "./factset/hostContextService";
import { isOfficeJsBypassed } from "./officeJsGuard";

export function shouldUseFactSetBridge(): boolean {
  if (!isOfficeJsBypassed() || !isFactSetIntentBridgeAvailable()) {
    return false;
  }
  // PPT intents are invalid in spreadsheet hosts. Unknown host context stays
  // backward-compatible by defaulting to PowerPoint routing.
  if (isFactSetSpreadsheetHost()) {
    return false;
  }
  return true;
}
